// AboutUss.js
import React from "react";
import Testimonialsabout from "./Testimonialsabout";
import VisionMissionnew from "./VisionMissionnew";
import AaryanStats from "./AaryanStats";

const aboutFeatures = [
  {
    id: 1,
    icon: "images/icon-about-trusted-1.svg",
    title: "easy booking process",
    description:
      "Our online and offline booking system makes reserving your ride effortless. Book in seconds through call, WhatsApp, or website — quick, transparent, and secure.",
    delay: "0.5s",
  },
  {
    id: 2,
    icon: "images/icon-about-trusted-2.svg",
    title: "convenient pick-up & return process",
    description:
      "Whether it’s a corporate transfer, airport drop, or outstation trip, we offer flexible pick-up and return options at your preferred time and location.",
    delay: "0.75s",
  },
];

const AboutUss = () => {
  return (
    <>
      {/* Page Header */}
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                  About Us
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div className="about-us page-about-us">
        <div className="container">
          <div className="row align-items-center">
            {/* About Us Images */}
            <div className="col-lg-6">
              <div className="about-image">
                <div className="about-img-1">
                  <figure className="reveal">
                    <img
                      src="images/mr-bade.png"
                      alt="About Aaryan Travels"
                    />
                  </figure>
                </div>
                {/* <div className="about-img-2">
                  <figure className="reveal">
                    <img
                      src="images/about-img-2.jpg"
                      alt="Aaryan Travels Fleet"
                    />
                  </figure>
                </div> */}
              </div>

               <div className="growth-journey">
              <h2 className="mb-3">Our Growth Journey</h2>
              <p>
                Since its inception, <strong>Aaryan Travels</strong> has
                been committed to expanding and diversifying its presence across
                India in response to the growing demands of the travel industry.
                With a customer-first approach and unwavering commitment to
                excellence, we have achieved consistent growth year after year.
              </p>
              <p>
                Today, we proudly operate in four major metro cities—
                <strong>Pune, Mumbai, Ahmedabad, New Delhi and Bangalore </strong>—along
                with multiple Tier-1 and Tier-2 cities nationwide, and our
                journey of expansion continues.
              </p>
             
            </div>
            </div>

            {/* About Us Content */}
            <div className="col-lg-6">
              <div className="about-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">about us</h3>
                  <h2 className="text-anime-style-3" data-cursor="-opaque">
                    Your trusted travel partner across India
                  </h2>

                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    <strong>Aaryan Travels</strong> is a leading travel service
                    provider specializing in{" "}
                    <strong>
                      corporate travel, airport transfers, and all-India car
                      rental solutions
                    </strong>
                    . We focus on delivering comfort, safety, and reliability
                    with every ride. From business meetings to airport commutes
                    and long-distance road trips, we make your journey smooth,
                    timely, and stress-free.
                  </p>

                  <p className="wow fadeInUp" data-wow-delay="0.35s">
                    Founded in 2015, <strong>Aaryan Travels</strong> is
                    a trusted name in travel services with operations across{" "}
                    <strong> Pune, Mumbai, Ahmedabad, New Delhi, Bangalore. </strong>
                    Guided by <strong>Mr. Pramod Bade</strong>,  our focus is on delivering safe, reliable, and premium-quality travel solutions to 
individuals and corporates alike.
                  </p>

                  <p className="wow fadeInUp" data-wow-delay="0.45s">
                    Our offices in <strong> Piimpri-Chinchwad (Pune) , Andheri East (Mumbai),  Vejalpur 
(Ahmedabad ) , Shahbad Mohammad Pur (New Delhi)  </strong> and{" "}
                    <strong>Ramachandrapuram 
(Bengaluru)</strong> enable us to serve a
                    wide range of travel needs efficiently and professionally.
                    Over the years, we’ve grown into a preferred partner for
                    business travelers, families, and tourists seeking
                    dependable travel solutions.
                  </p>
 <h3 className="mt-4">Our Core Strength – The Trust of Our Clients</h3>
              <p>
                The trust and loyalty of our repeat clients remain our greatest
                achievement. Their confidence inspires us to innovate, improve,
                and raise industry standards. Backed by a dedicated leadership
                team and a passionate workforce, we continuously strive to set
                new benchmarks in service quality and customer satisfaction.
              </p>
                  {/* <p className="wow fadeInUp" data-wow-delay="0.55s">
                    With a fleet of clean, well-maintained vehicles and
                    professional chauffeurs, Aaryan Travels is committed to
                    offering top-tier transportation services to individuals,
                    companies, and travel enthusiasts across India.
                  </p> */}
                  
                </div>

                <div className="about-content-body">
                  {aboutFeatures.map((feature) => (
                    <div
                      key={feature.id}
                      className="about-trusted-booking wow fadeInUp"
                      data-wow-delay={feature.delay}
                    >
                      <div className="icon-box">
                        <img src={feature.icon} alt={feature.title} />
                      </div>
                      <div className="trusted-booking-content">
                        <h3>{feature.title}</h3>
                        <p>{feature.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Vision & Mission Section */}
      <VisionMissionnew />
<AaryanStats />
      {/* Testimonials Section */}
      <Testimonialsabout />
    </>
  );
};

export default AboutUss;
